import { css } from 'styled-components';

export const SelectionHolder = css`
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.theme.color};
  font-size: 19px;
  font-weight: 700;
  cursor: pointer;
`;

export const Selection = css`
  position: relative;
  display: block;
  height: 18px;
  width: 18px;
  margin: 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 2px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  border-radius: 2px;
  outline: none;
  cursor: pointer;

  ${(props) =>
    props.isSelected &&
    css`
      border: 2px solid ${(props) => props.theme.borderOnCheckmark};
      background: ${(props) => props.theme.backgroundOnCheckmark};
    `}
`;

export const SelectionInput = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
`;

export const SelectionCheckmark = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
  transform: translate(-50%, -50%);
  opacity: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;

  ${(props) =>
    props.isSelected &&
    css`
      opacity: 1;
      color: ${(props) => props.theme.colorOnCheckmark};
    `}
`;
